import React from 'react';
import { Icon, IconName } from './icons';

type IconBadgeProps = {
  name: IconName;
  size?: 44 | 56;
  /** teal: teal disc, white icon. inverse: white disc, teal icon (for deep-teal bands). */
  tone?: 'teal' | 'inverse';
  className?: string;
};

const IconBadge: React.FC<IconBadgeProps> = ({ name, size = 44, tone = 'teal', className }) => {
  const classes = ['ui-icon-badge', `ui-icon-badge--${size}`];
  if (tone === 'inverse') classes.push('ui-icon-badge--inverse');
  if (className) classes.push(className);
  return (
    <span className={classes.join(' ')} aria-hidden="true">
      <Icon name={name} size={size === 56 ? 28 : 22} />
    </span>
  );
};

export default IconBadge;
